module.exports = __webpack_public_path__ + "img/Cut out parts_Dolphin.02c24f7f.png";